
/* injects from baggage-loader */

'use strict';
import { FormTypes,  FormColors } from '_appRoot/index.const';
import { concat, filter, map } from 'lodash';

export default class StageBookQuizController {
    constructor($log, $scope, $rootScope, $state, $Forms, $timeout, Dialog) {
        'ngInject';
        this.$log = $log;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$timeout = $timeout;
        this.$Forms = $Forms;
        this.Dialog = Dialog;
        this.textHelp = 'RESPONDA AS PERGUNTAS COM AJUDA DOS BOTÕES CORRESPONDENTES.';
        this.state = {
            step: 1,
        }
    }

    inArray(item, array) {
    return (array.indexOf(item) !== -1);
    }

   
    bindForm(key, form){
        this[key] = form;
    }

    onSubmit(){
        this.onSuccess();
    }

    onSubmitQuiz1(){
        this.questions.f1.q1.error = this.f1Q1Validation();        
        this.questions.f1.q2.error = this.f1Q2Validation();        
        this.questions.f1.q3.error = this.f1Q3Validation();        
        this.questions.f1.q4.error = this.f1Q4Validation();    

        let errors = map(this.questions.f1, q => q.error);
        let errorSize = filter(errors, e => e === true).length;
        
        


        if (errorSize){

            this.Dialog.showAlert('Opa!','Parece que você se confundiu. Confira de novo as respostas destacadas em vermelho.',true)
            return false
        }

        this.nextStep()

    }

    onSubmitQuiz2(){
        this.questions.f2.q1.error = !this.f2Q1Validation();        
        this.questions.f2.q2.error = !this.f2Q2Validation();        

        let errors = map(this.questions.f2, q => q.error );
        let errorSize = filter(errors, e => e === true).length;

        
        
        if (errorSize){
            this.questions.f2.q1.answer = this.questions.f2.q1.value;
            this.questions.f2.q2.answer = this.questions.f2.q2.value;

            if(this.questions.f2.q1.error){
                this.questions.f2.q1.errors = concat(this.questions.f2.q1.errors, this.questions.f2.q1.value);
            }
            if(this.questions.f2.q2.error){
                this.questions.f2.q2.errors = concat(this.questions.f2.q2.errors, this.questions.f2.q2.value);
            }

            this.Dialog.showAlert('Opa!','Parece que você se confundiu. Confira de novo as respostas destacadas em vermelho.',true);
            return false;
        }

        //alert("Tudo certo");

        this.onSubmit();

    }

    nextStep(){
        if(this.state.step < 2){
            return this.state.step++;
        } else {
            return false;
        }
    }

    f1Q1Validation() {
        let data = concat(this.forms.group1, this.forms.group2, this.forms.group3);
        let response = filter(data, { type: FormTypes.triangle });

        return response.length !== parseInt(this.questions.f1.q1.value);
    }

    f1Q2Validation() {
        let data = concat(this.forms.group1, this.forms.group2, this.forms.group3);
        let response = filter(data, { type: FormTypes.rect });

        return response.length !== parseInt(this.questions.f1.q2.value);
    }


    f1Q3Validation() {
        let data = concat(this.forms.group1, this.forms.group2, this.forms.group3);
        let response = filter(data, { color: FormColors.blue });

        return response.length !== parseInt(this.questions.f1.q3.value);
    }

    f1Q4Validation() {
        let data = concat(this.forms.group1, this.forms.group2, this.forms.group3);
        let response = filter(data, { color: FormColors.yellow });

        return response.length !== parseInt(this.questions.f1.q4.value);
    }

    f2Q1Validation(){
        let data = concat(this.forms.group1, this.forms.group2, this.forms.group3);

        let response = true;

        let red = filter(data, { color: FormColors.red });
        let blue = filter(data, { color: FormColors.blue });
        let yellow = filter(data, { color: FormColors.yellow });

        let answer = this.questions.f2.q1.value;

        switch (answer) {
            case 1:
                response = yellow.length > blue.length;
                break;    
            case 2:
                response = yellow.length < blue.length;
                break;
            case 3:
                response = blue.length === red.length;
                break;
            default:
                break;
        }

        return response;
    }
    
    f2Q2Validation(){
        let data = concat(this.forms.group1, this.forms.group2, this.forms.group3);

        let response = false;

        let rect = filter(data, { type: FormTypes.rect });
        let circle = filter(data, { type: FormTypes.circle });
        let triangle = filter(data, { type: FormTypes.triangle });

        let answer = this.questions.f2.q2.value;

        switch (answer) {
            case 1:
                response = circle.length > rect.length;
                break;
            case 2:
                response = circle.length < rect.length;
                break;
            case 3:
                response = triangle.length === rect.length;
                break;
            default:
                break;
        }

        return response;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/stage-book-quiz/stage-book-quiz.controller.js